import useKeypress from "react-use-keypress";

import useShortcuts from "./useShortcuts";

const disabledOnElements = ["TEXTAREA", "INPUT", "SELECT", "BUTTON"];
const disabledOnClassName = ["editor-input"];

const transformKeys = (keys) => {
	return keys.map((key) => {
		if (key.includes("+")) {
			const [, basicKey] = key.split("+");

			return basicKey.trim();
		}

		return key;
	});
};

export function useKeyPress(keys, cb) {
	const { isShortcutsOn } = useShortcuts();
	return useKeypress(transformKeys(keys), (event) => {
		if (!isShortcutsOn) {
			return null;
		}

		if (
			disabledOnElements.includes(document.activeElement.tagName) ||
			disabledOnClassName.includes(document.activeElement.className) ||
			document.activeElement.getAttribute("contenteditable") === "true"
		) {
			return null;
		}
		const combination = keys.find((key) => key.includes(event.key));
		const isMetaRequired = ["Meta"].some((metaKey) =>
			combination.includes(metaKey),
		);
		if (!isMetaRequired && (event.metaKey || event.ctrlKey)) {
			return null;
		}

		if (isMetaRequired && !(event.metaKey || event.ctrlKey)) {
			return null;
		}

		event.stopPropagation();
		event.preventDefault();
		return cb(event);
	});
}
